import { useTranslation } from "react-i18next";
import PanelsLayout from "components/PanelsLayout";
import { useState } from "react";
import { useParams } from "react-router-dom";
import EmptyPanel from "components/EmptyPanel";
import { useDebounce } from "use-debounce";
import UserRightSide from "components/Admin/UserRightSide";
import UsersList from "components/Admin/UsersList";
import UserRegister from "components/Admin/UserRegister";
import AddressBookVerificationsGrid from "components/AddressBookVerificationsManager";
import BaeRegister from "components/Admin/BaeRegister";
import WorkspaceKeyHealth from "components/Admin/WorkspaceKeyHealth";

const AdminModule = () => {
  const { t } = useTranslation();
  const { view, userId } = useParams();
  const [searchText, setSearchText] = useState("");
  const [debouncedText] = useDebounce(searchText, 300);

  const handleChangeSearchBar = (text: string) => setSearchText(text);

  const leftPanel = () => {
    if (view === "users") {
      return <UsersList searchText={debouncedText}></UsersList>;
    }

    if (view === "userRegistry") {
      return <UserRegister searchText={debouncedText}></UserRegister>;
    }

    if (view === "addressBookVerifications") {
      return (
        <AddressBookVerificationsGrid
          searchText={debouncedText}
        ></AddressBookVerificationsGrid>
      );
    }

    if (view === "baeRegistry") {
      return <BaeRegister searchText={debouncedText}></BaeRegister>;
    }

    if (view === "userWorkspaces") {
      return (
        <WorkspaceKeyHealth searchText={debouncedText}></WorkspaceKeyHealth>
      );
    }

    return <div>todo</div>;
  };

  const getLeftPanelTitle = () => {
    if (view === "userRegistry") return t("admin.clientRegistry");
    if (view === "addressBookVerifications")
      return t("admin.addressBookVerifications");
    if (view === "baeRegistry") return t("admin.baeRegistry");
    if (view === "userWorkspaces")
      return t("admin.workspaceKeyHealth.title", "Firmy i klucze");
    return t("admin.clients");
  };

  const getLeftPanelSubtitle = () => {
    return t("admin.all");
  };

  const rightPanel = () => {
    if (!userId) {
      return <EmptyPanel />;
    }

    return (
      <>
        <UserRightSide userId={userId} />
        {/* <ClientNew clientId={clientId} /> */}
      </>
    );
  };

  return (
    <PanelsLayout
      title={getLeftPanelTitle()}
      subTitle={getLeftPanelSubtitle()}
      onChangeSearch={handleChangeSearchBar}
      leftPanel={leftPanel()}
      hideRight={
        view === "userRegistry" ||
        view == "addressBookVerifications" ||
        view == "baeRegistry" ||
        view == "userWorkspaces"
      }
      rightPanel={rightPanel()}
    />
  );
};
export default AdminModule;
